import Vue from 'vue';
import Vuex, { MutationTree, ActionTree, GetterTree } from 'vuex';

import { IRegisterState } from '../models/store-viewmodel';
import { IFormError } from '../models/form-error-viewmodel';
import { IConfig } from '../models/config-viewmodel';
import { Offering, Study } from '@/shared/models/view/study-viewmodel';
import { Country } from '@/shared/models/view/country-viewmodel';
import { University } from '@/shared/models/view/university-viewmodel';

import { root } from '@/shared/store/index';
import { Identification } from '@/shared/models/view/identification-viewmodel';
import {Option} from "@/shared/models/view/option-viewmodel";

Vue.use(Vuex);

const state: IRegisterState = {
    submit: false,
    errors: [],
    formErrors: {},
    form: {},
    preform: {},
    activeView: '',
    config: {
        language: '',
        captchaKey: ''
    },
    offerings: [],
    countries: [],
    universities: [],
    identifications: [],
    studies: [],
    loading: true,
    isDisabled: false,
}

const mutations: MutationTree<IRegisterState> = {
    setFormValue(state, {name, value}) {
        Vue.set(state.form, name, value);
    },

    setPreFormValue(state, {key, value}) {
        Vue.set(state.preform, key, value);
    },

    removeFormValue(state, key) {
        Vue.delete(state.form, key);
    },

    removePreFormValue(state, {key, value}) {
        Vue.delete(state.preform, key);
    },

    resetFormValues(state) {
        Vue.set(state, 'form', {});
    },

    resetPreFormValues(state) {
        Vue.set(state, 'preform', {});
    },

    setActiveView(state, view: string) {
        state.activeView = view;
    },

    setSubmit(state, submit: boolean) {
        state.submit = submit;
    },

    addError(state, error: IFormError) {
        state.errors.push(error);
    },

    removeError(state, key: string) {
        state.errors = state.errors.filter((error: IFormError) => error.key !== key);
    },

    addFormErrors(state, {name, error}) {
        if (state.formErrors[name]) {
            state.formErrors[name].push(error)
        } else {
            Vue.set(state.formErrors, name, [error]);
        }
    },

    removeFormErrors(state, name: string) {
        Vue.delete(state.formErrors, name);
    },

    resetFormErrors(state) {
        Vue.set(state, 'formErrors', {});
    },

    setConfig(state, config: IConfig) {
        state.config = config;
    },

    setOfferings(state, offerings: Offering[]) {
        state.offerings = offerings;
    },

    setCountries(state, countries: Country[]) {
        state.countries = countries;
    },

    setUniversities(state, universities: University[]) {
        state.universities = universities;
    },

    setIdentification(state, identifications: Identification[]) {
        state.identifications = identifications;
    },

    setStudies(state, studies: Study[]) {
        state.studies = studies;
    },

    setLoading(state, loading: boolean) {
        state.loading = loading;
    },
    
    setDisabled(state, isDisabled: boolean) {
        state.isDisabled = isDisabled;
    }
}

const actions: ActionTree<IRegisterState, IRegisterState> = {
    resetFormValues({commit}) {
        commit('resetFormValues');
    },

    resetPreFormValues({commit}) {
        commit('resetPreFormValues');
    },
}

const getters: GetterTree<IRegisterState, IRegisterState> = {
    getError: (state) => (key: string) => {
        return state.errors.find((error: IFormError) => error.key === key);
    },

    getFormErrors: (state) => (key: string): any => {
        return state.formErrors[key];
    },

    getTotalErrors(state) {
        return Object.keys(state.formErrors).length;
    },

    config(state) {
        return state.config;
    },
    
    getIsDisabled (state): boolean {
        return state.isDisabled;
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        root
    }
})